/* Embroidery Inc homepage 2026-10: smooth open/close for the FAQ <details> (#faq).
   Native <details> keeps working without JS; with reduced motion or Save-Data the native toggle is used.
   Perf: one delegated click listener per FAQ list, so page load does no per-question work. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var saveData = navigator.connection && navigator.connection.saveData;
  var EASE = 'cubic-bezier(.2,.7,.2,1)';

  function still() { return (mq && mq.matches) || saveData; }

  function onClick(e) {
    if (still()) return;
    var summary = e.target.closest ? e.target.closest('summary') : null;
    var item = summary && summary.parentNode;
    if (!item || item.tagName !== 'DETAILS' || item.querySelector('summary') !== summary || !this.contains(item)) return;
    var panel = item.querySelector('.ei-faq__a');
    if (!panel || !panel.animate) return;
    e.preventDefault();
    var from = panel.getBoundingClientRect().height;
    if (item.__eiAnim) { item.__eiAnim.cancel(); item.__eiAnim = null; }
    var closing = item.open && !item.classList.contains('is-closing');
    var anim;

    if (closing) {
      item.classList.add('is-closing');
      anim = item.__eiAnim = panel.animate(
        [{ height: from + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: 220, easing: EASE }
      );
      anim.onfinish = function () { item.open = false; item.classList.remove('is-closing'); item.__eiAnim = null; };
    } else {
      if (!item.open) from = 0;
      item.classList.remove('is-closing');
      item.open = true;
      var to = panel.scrollHeight;
      anim = item.__eiAnim = panel.animate(
        [{ height: from + 'px', opacity: from ? 1 : 0 }, { height: to + 'px', opacity: 1 }],
        { duration: 280, easing: EASE }
      );
      anim.onfinish = function () { item.__eiAnim = null; };
    }
  }

  /* Sections marked data-ei-cv use content-visibility: auto, so one that has not been shown yet only
     holds an estimated height. Render the ones above the target first so the scroll lands exactly. */
  function settle(target) {
    var cv = document.querySelectorAll('[data-ei-cv]');
    for (var i = 0; i < cv.length; i++) {
      if (cv[i].compareDocumentPosition(target) & 4) cv[i].style.contentVisibility = 'visible';
    }
  }

  /* In-page links (#id) scroll natively (the theme makes that smooth). Settle the estimated sections
     above the target first, so the browser computes the final spot from real heights. Registered once. */
  if (!window.__eiCvLinks) {
    window.__eiCvLinks = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a || !a.hash || a.hash.length < 2 || a.href.split('#')[0] !== location.href.split('#')[0]) return;
      var t;
      try { t = document.getElementById(decodeURIComponent(a.hash.slice(1))); } catch (err) { return; }
      if (t) settle(t);
    }, true);
  }

  function run() {
    var lists = document.querySelectorAll('[data-ei-faq]');
    for (var i = 0; i < lists.length; i++) {
      if (lists[i].__eiFaq) continue;
      lists[i].__eiFaq = true;
      lists[i].addEventListener('click', onClick);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
